// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"488":"axiom","532":"styles","592":"common","736":"vendor"}[chunkId] || chunkId) + "." + {"60":"74d36e1685ddb9232091","488":"f3c9d288cdff8b0d2d85","532":"7ea257594c81849b51b2","592":"63616c321b73b09f96e0","736":"42e3f18ee8f7a879818d"}[chunkId] + ".js";
};